import { useTransactionInitiateMutation } from "Api/Mutations/Transactions/useTransactionInitiateMutation";
import { useNavigate } from "Navigation/useNavigate";
import { appUrl } from "Utils/UrlUtils";
import type {
  ErrorResponse,
  InitiateTransactionRequest,
} from "Infrastructure/Api/Api";

type Props = {
  onError?: (
    error: ErrorResponse,
    variables: InitiateTransactionRequest,
  ) => void;
};

export const useTransactionInitiate = ({ onError }: Props = {}) => {
  const navigate = useNavigate();

  return useTransactionInitiateMutation({
    onSuccess: (result) => {
      if (result.transaction?.publicID !== undefined) {
        navigate(
          `${appUrl("initiate-payment-detail")}/${result.transaction.publicID}`,
        );
      }
    },
    onError,
  });
};
